import * as React from 'react';
import { observer } from 'mobx-react';
import { FormField, IFormFieldProps } from './form-field';
import { CheckboxList, CheckboxListOptionValue, ICheckboxListCommonProps } from '../primitives/checkbox-list';
import { classNames } from '../../utils/classnames';
import { BaseFieldState } from './base-field-state';
import { ModelMetadata } from '../../../LoggedInWeb/loggedinweb-generated';

export class CheckboxListFieldState extends BaseFieldState<CheckboxListOptionValue[]> {
	constructor(initialValue: CheckboxListOptionValue[], metadata?: ModelMetadata.IPropertyMetadata) {
		super(initialValue, metadata);
	}
}

export type ICheckboxListFieldProps = ICheckboxListCommonProps & IFormFieldProps & { fieldState: CheckboxListFieldState };

@observer
export class CheckboxListField extends React.Component<ICheckboxListFieldProps> {
	render() {
		const { label, className, tooltip, fieldState, additionalClassNames, ...rest } = this.props;
		const { value, onChange, hasError, error } = fieldState;
		const classes = classNames(additionalClassNames, hasError ? `input-validation-error` : null);

		return (
			<FormField label={label} className={className} tooltip={tooltip} error={error}>
				<CheckboxList
					{...rest}
					onChange={onChange}
					selectedValues={value}
					ariaInvalid={hasError}
					additionalClassNames={classes}
				/>
			</FormField>
		);
	}
}
